'use strict';

var _txSend = require('@tencent/tx-send');

var _txSend2 = _interopRequireDefault(_txSend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  extend: function extend(theTarget) {
    var target = theTarget;

    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    rest.forEach(function (source) {
      Object.keys(source).forEach(function (key) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      });
    });

    return target;
  },
  isArray: function isArray(obj) {
    return obj && Object.prototype.toString.call(obj) === '[object Array]';
  },


  param: _txSend2.default.param,

  send: _txSend2.default.send
};